import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Textarea } from '@/components/ui/textarea';

type Props = {
  value: string;
  submitting: boolean;
  onChange: (value: string) => void;
  onNext: () => void;
  onCancel: () => void;
};

export function ToneAvoidStep({ value, submitting, onChange, onNext, onCancel }: Props) {
  return (
    <div className="space-y-4">
      <Card className="p-5 space-y-3 shadow-sm">
        <div className="text-xs font-semibold tracking-wide text-muted-foreground">
          Cose da evitare
        </div>
        <p className="text-sm text-muted-foreground">
          Parole, toni o abitudini che non vuoi vedere nell&apos;assistente (facoltativo).
        </p>
        <Textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Esempio: niente emoji, evita diminutivi, non usare sarcasmo..."
          className="min-h-[140px]"
        />
      </Card>
      <div className="flex gap-3 justify-end">
        <Button variant="outline" disabled={submitting} onClick={onCancel}>
          Annulla
        </Button>
        <Button disabled={submitting} onClick={onNext} isLoading={submitting}>
          Vai al riepilogo
        </Button>
      </div>
    </div>
  );
}
